<template lang="pug">
.order-mass
  OrderDataNoveltyBadge

  .order-mass__sticky
    .order-mass__record-filters(v-if="!isLoading")
      button.order-mass__record-filter-tag(
        v-for="tag in massFilterTags"
        :key="tag.key"
        type="button"
        :class="{ 'is-active': massFilters[tag.key] }"
        :style="massFilterTagStyle(tag.key)"
        @click="toggleMassFilter(tag.key)"
      ) {{ tag.label }}

    .order-mass__actions(v-if="displayOrders.length && !isLoading")
      .order-mass__toolbar(v-if="selectedCount")
        shActionButton(
          :action="deleteOrders"
          icon="close"
          text="Borrar órdenes"
          textRunning="Borrando"
          :normalColor="true"
          :textConfirmation="`Se borrarán ${orders.length} órdenes cargadas`"
        )
        shActionButton(
          :action="downloadLabelsAll"
          icon="download"
          text="Descargar Guías"
          textRunning="Descargando Guías"
          :normalColor="true"
          :textConfirmation="`Se descargarán las guías para ${selectedCount} pedidos`"
        )
        shActionButton(
          :action="quoteAll"
          icon="request_quote"
          text="Cotizar"
          textRunning="Cotizando"
          :normalColor="true"
          :textConfirmation="`Se cotizarán las órdenes para ${selectedCount} pedidos`"
        )
        shActionButton(
          v-if="canGenerateDeliverySelected"
          :action="generateDeliveryAll"
      icon="package_2"
      text="Generar Guías"
          textRunning="Generando Guías"
          :normalColor="true"
          :textConfirmation="`Se generarán las guías para ${selectedCount} pedidos`"
        )
        shActionButton(
          :action="sendAll"
          text="Enviar"
          textRunning="Enviando"
          :normalColor="true"
          :textConfirmation="`Se enviarán ${selectedCount} pedidos seleccionados`"
        )

      p.order-mass__status-count
        b {{ displayOrders.length }}
        |  {{ ordersCountLabel }}
        template(v-if="selectedCount")
          |  |
          b  {{ selectedCount }}
          |  {{ selectedCountLabel }}

    .order-mass__table-header(v-if="displayOrders.length")
      .order-mass__row.order-mass__row--header
        .order-mass__cell.order-mass__col-check
          shCheckbox(:value="allOrdersSelected" @input="setAllOrdersSelected" :icon-color="massCheckIconColor" :icon-size="massCheckIconSize")
        .order-mass__cell.order-mass__col-id Orden
        .order-mass__cell.order-mass__col-status Estado
        .order-mass__cell.order-mass__col-location Ciudad
        .order-mass__cell.order-mass__col-date Fecha
        .order-mass__cell.order-mass__col-declared Declarado
        .order-mass__cell.order-mass__col-value Valor
        .order-mass__cell.order-mass__col-package Tamaño
        .order-mass__cell.order-mass__col-guide.order-mass__guide-header(@click="cycleGuideSelection") Guía
        .order-mass__cell.order-mass__col-message Mensajes
        .order-mass__cell.order-mass__col-actions

  .order-mass__body
    .order-mass__row.order-mass__row--loader(v-if="isLoading")
      LoaderMini

    template(v-if="displayOrders.length && !isLoading")
      .order-mass__row(
        v-for="order in displayOrders"
        :key="order.order"
        :class="{ 'is-selected': order.checked }"
      )
        .order-mass__cell.order-mass__col-check
          shCheckbox(:value="order.checked" @input="setOrderChecked(order, $event)" :icon-color="massCheckIconColor" :icon-size="massCheckIconSize")
        .order-mass__cell.order-mass__col-id
          span.tag.uppercase.order-mass__order-link(:class="`bg-${order.brand}`" @click="goToOrder(order)") {{ order.order }}
        .order-mass__cell.order-mass__col-status
          .tag.order-mass__status-label(:style="orderTagStyle(order.status)") {{ statusLabel(order.status) }}
          .tag.order-mass__quantity {{ productQuantity(order) }}
        .order-mass__cell.order-mass__col-location.capitalize {{ cutValue(order.location) }}
        .order-mass__cell.order-mass__col-date {{ dateName(order.createdAt) }}
        .order-mass__cell.order-mass__col-declared
          span.label-declared(v-if="order.showDeclared" @click="showDeclared(order, false)") {{ money(order.declared) }}
          span(v-else)
            input.input.input-declared(:ref="`declared${order.order}`" @blur="showDeclared(order, true)" @keyup.enter="showDeclared(order, true)" v-model.number="order.declared" autocomplete="ño" type="number" min="1")
        .order-mass__cell.order-mass__col-value {{ money(order.value) }}
        .order-mass__cell.order-mass__col-package
          PackageSize(
            :order="order"
            multiple
            :opened="openedPackageOrder === order.order"
            @update:opened="openedPackageOrder = $event ? order.order : null"
          )
        .order-mass__cell.order-mass__col-guide(@click.stop="")
          DeliveryDataIcon(:record="order" @refresh="refreshOrderRecord(order)")
          select.order-mass__carrier(:aria-label="`Transportadora ${order.order}`" v-if="canChooseConveyor(order)" :value="carrierFor(order)" :disabled="hasGuide(order) || order.selectingConveyor" @change="selectConveyor(order, $event)")
            option(value="welivery") Welivery
            option(value="coordinadora") Coordinadora
          span.capitalize(v-else) {{ carrierFor(order) }}
          span.order-mass__quote-cost(v-if="displayFreightCost(order)") {{ money(displayFreightCost(order)) }}
        .order-mass__cell.order-mass__col-message.message-mass
          .color-green(v-if="order.success") {{ order.success }}
          .color-red(v-if="order.error") {{ order.error }}
        .order-mass__cell.order-mass__col-actions.container-actions-mass
          shActionButton(v-if="canDownloadDelivery(order)" :action="downloadTracking" :params="[order]" icon="download" text="Descargar" textRunning="Descargando" :normalColor="true")
          shActionButton(v-if="canDownloadDelivery(order) && carrierFor(order) === 'welivery'" :action="downloadOriginalWelivery" :params="[order]" icon="picture_as_pdf" text="Original" textRunning="Descargando" :normalColor="true")
          shActionButton(v-if="canQuoteOrder(order)" :action="getQuoteCoordinadora" :params="[order]" icon="request_quote" text="Cotizar" textRunning="Cotizando" :normalColor="true")
          shActionButton(v-if="canGenerateDelivery(order)" :action="generateDelivery" :params="[order]" :icon="order.isWholesaler ? 'inventory_2' : 'package_2'" text="Generar Guía" textRunning="Generando Guía" :normalColor="true" :textConfirmation="`Se generará la guía para la orden ${capitalize(order.order)}`")
          shActionButton(v-if="canGenerateCollectFreightDelivery(order)" :action="generateDeliveryCollectFreight" :params="[order]" icon="inventory_2" text="Guía al cobro" textRunning="Generando al cobro" :normalColor="true" :textConfirmation="`Se generará la guía al cobro para ${capitalize(order.order)}. Flete estimado ${money(order.coordinadoraCost)} lo paga el cliente.`")
          shActionButton(:action="deleteOrder" :params="[order]" icon="close" text="Quitar" textRunning="Quitando")

  KeyboardTypingOverlay(:active="true" input-label="Pedido" @submit="onSubmit")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlChange from '@/graphql/change'
import gqlUser from '@/graphql/user'
import gqlCoordinadora from '@/graphql/coordinadora'
import gqlWelivery from '@/graphql/welivery'
import modals from '@my/store/modals'
import { mapState, mapActions, mapMutations } from 'vuex'
import LoaderMini from '@/components/layout/LoaderMini.vue'
import shCheckbox from '@/components/elements/Checkbox'
import DeliveryDataIcon from '@/components/elements/delivery/DeliveryDataIcon.vue'
import KeyboardTypingOverlay from '@/components/keyboard/TypingOverlay.vue'
import OrderDataNoveltyBadge from '@/components/elements/order/OrderDataNoveltyBadge.vue'
import PackageSize from '@/components/elements/PackageSize.vue'
import { matchesPackRecordFilters } from '@/helpers/packSearch'
import { recordProductQuantity } from '@/helpers/productQuantity'
import { canDownloadDeliveryLabel, latestDeliveryDiffersFromRecord, getLatestDelivery } from '@/helpers/deliveryMass'
import { guidePackagesError, guidePackagesInput, packageDimensionsPayload } from '@/helpers/packageSize'
import { isBlockedByAddressNovelty, addressNoveltyBlockMessage } from '@/helpers/orderNovelty'

export default {
  name: 'OrderMass',

  mixins: [mForm, mFilters],

  components: { LoaderMini, DeliveryDataIcon, KeyboardTypingOverlay, shCheckbox, OrderDataNoveltyBadge, PackageSize },

  data () {
    return {
      order: '',
      users: [],
      sounds: {
        beepError: 'beep_error.mp3',
        beep: 'beep.mp3',
        error: 'error.mp3',
        tier: 'tier.mp3'
      },
      audios: {
        beepError: '',
        beep: '',
        error: '',
        tier: ''
      },
      massCheckIconColor: 'var(--color-placeholder)',
      massCheckIconSize: '1.75rem',
      massFilterTags: [
        { key: 'bassica', label: 'Bássica' },
        { key: 'sahet', label: 'Sahet' },
        { key: 'bogota', label: 'Bogotá' },
        { key: 'nacional', label: 'Nacional' }
      ],
      massFilters: {
        bassica: false,
        sahet: false,
        bogota: false,
        nacional: false
      },
      statusSpanish: {
        created: 'Creado',
        approved: 'Aprobado',
        paid: 'Pagado',
        packed: 'Empacado',
        sent: 'Enviado',
        declined: 'Declinado',
        expired: 'Expirado'
      },
      contentParent: null,
      scrollParent: null,
      resizeHandler: null,
      guideSelectWithGuideNext: false,
      openedPackageOrder: null
    }
  },

  computed: {
    ...mapState('mass', ['orders', 'isLoading']),

    displayOrders () {
      return this.orders.filter(order => matchesPackRecordFilters(order, this.massFilters))
    },

    selectedCount () {
      return this.displayOrders.filter(order => order.checked).length
    },

    allOrdersSelected () {
      if (!this.displayOrders.length) return false
      return this.displayOrders.every(order => order.checked)
    },

    ordersCountLabel () {
      const count = this.displayOrders.length
      return count === 1 ? 'orden' : 'órdenes'
    },

    selectedCountLabel () {
      return this.selectedCount === 1 ? 'seleccionada' : 'seleccionadas'
    },

    canGenerateDeliverySelected () {
      return this.displayOrders.some(order =>
        order.checked && (this.canGenerateDelivery(order) || this.canGenerateCollectFreightDelivery(order))
      )
    }
  },

  watch: {
    orders: {
      handler () {
        if (this.isLoading) return
        this.persistSession()
      },
      deep: true
    }
  },

  mounted () {
    this.contentParent = this.$el.classList.contains('box')
      ? this.$el
      : this.$el.closest('.content.box')
    this.scrollParent = this.$el.closest('.content-section')

    if (this.contentParent) {
      this.contentParent.classList.add('order-mass-page')
    }
    if (this.scrollParent) {
      this.scrollParent.classList.add('order-mass-scroll')
    }

    this.resizeHandler = () => this.updateMassHeight()
    window.addEventListener('resize', this.resizeHandler)

    this.getUsers()
    this.loadFromSession()
    this.$nextTick(() => this.updateMassHeight())
  },

  updated () {
    this.$nextTick(() => this.updateMassHeight())
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler)

    if (this.contentParent) {
      this.contentParent.classList.remove('order-mass-page')
      this.contentParent.style.height = ''
      this.contentParent.style.maxHeight = ''
    }
    if (this.scrollParent) {
      this.scrollParent.classList.remove('order-mass-scroll')
    }
  },

  methods: {
    ...mapActions('mass', ['fetchMassOrder', 'fetchMassChange', 'loadFromSession', 'clearAll', 'persistSession']),
    ...mapMutations('mass', ['setMassOrderChecked', 'setMassAllChecked', 'removeMassOrder']),

    statusLabel (status) {
      return this.statusSpanish[status] || status
    },

    productQuantity (order) {
      return recordProductQuantity(order)
    },

    cutValue (value) {
      if (!value) return ''
      const maxLength = 8
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    },

    orderTagStyle (status) {
      const colors = this.colorsStatus[status]
      if (!colors) return {}
      return {
        background: colors.background,
        color: colors.color
      }
    },

    setAllOrdersSelected (value) {
      this.displayOrders.forEach(order => {
        this.setMassOrderChecked({ order: order.order, value })
      })
    },

    setOrderChecked (order, value) {
      this.setMassOrderChecked({ order: order.order, value })
    },

    async refreshOrderRecord (order) {
      if (order.change) await this.getDataChange(order.order, false)
      else await this.getDataOrder(order.order, false)
    },

    updateMassHeight () {
      if (!this.scrollParent || !this.contentParent) return

      const sectionRect = this.scrollParent.getBoundingClientRect()
      const top = this.contentParent.getBoundingClientRect().top
      const height = Math.max(sectionRect.bottom - top, 0)

      this.contentParent.style.height = `${height}px`
      this.contentParent.style.maxHeight = `${height}px`
    },

    async onSubmit (value) {
      this.order = value
      await this.getData()
    },

    async chargeOrders () {
      await this.loadFromSession()
    },

    deleteOrders () {
      this.clearAll()
    },

    goToOrder (order) {
      const key = order.change ? `c${order.change}` : order.order
      window.open(`/orders?Order=${key}`, '_blank')
    },

    deleteOrder (order) {
      this.removeMassOrder(order.order)
      return true
    },

    carrierFor (order) {
      const delivery = getLatestDelivery(order)
      return (delivery && (delivery.tracking || delivery.idWelivery || delivery.idRemission) && delivery.conveyor) || order.conveyor || 'coordinadora'
    },

    canChooseConveyor (order) {
      return !!(order.weliveryEnabled && !order.change && order.location === 'bogota' &&
        order.methodPay && !['cod', 'factory'].includes(order.methodPay) && !order.userPayConveyor)
    },

    hasGuide (order) {
      const delivery = getLatestDelivery(order)
      return !!(delivery && delivery.status !== 'declined' &&
        (delivery.idRemission || delivery.idWelivery || delivery.tracking))
    },

    async selectConveyor (order, event) {
      const conveyor = event.target.value
      event.target.value = this.carrierFor(order)
      this.$set(order, 'selectingConveyor', true)
      const errors = []
      try {
        const response = await gql.mutate(gqlWelivery.SELECT_CONVEYOR, { order: order.order, conveyor }, false, errors)
        if (errors.length || !response) {
          order.error = errors[0] || 'No se pudo seleccionar la transportadora'
          return false
        }
        this.$set(order, 'conveyor', conveyor)
        this.$set(order, 'coordinadoraCost', null)
        const delivery = getLatestDelivery(order)
        if (delivery) this.$set(delivery, 'conveyor', conveyor)
        order.error = ''
        order.success = conveyor === 'welivery' ? 'Welivery seleccionado · Costo provisional $10.000' : 'Coordinadora seleccionada'
        return true
      } finally { this.$set(order, 'selectingConveyor', false) }
    },

    printWelivery (orders) {
      const token = Date.now().toString(36)
      const records = []
      orders.forEach(order => {
        const delivery = getLatestDelivery(order)
        const count = delivery.weliveryPackageCount || 1
        for (let index = 1; index <= count; index++) {
          records.push({ order: order.order,
            name: delivery.nameRecipient,
            address: delivery.addressRecipient,
            phones: delivery.phonesRecipient,
            location: delivery.locationRecipient,
            community: order.community,
            packageNumber: index,
            packageCount: count,
            deliveries: [delivery] })
        }
      })
      sessionStorage.setItem('welivery-print-' + token, JSON.stringify(records))
      const route = this.$router.resolve({ name: 'TrackingDeliveryPrint', query: { batch: token } })
      const opened = window.open(route.href, '_blank')
      if (!opened) modals.showMessage({ message: 'Permite abrir ventanas para imprimir los rótulos Welivery', type: 'error' })
      return true
    },

    async downloadOriginalWelivery (order) {
      const tab = window.open('about:blank', '_blank')
      const errors = []
      try {
        const response = await gql.mutate(gqlWelivery.GENERATE_LABELS_WELIVERY, { deliveries: [getLatestDelivery(order).delivery] }, false, errors)
        if (errors.length || !response) throw new Error(errors[0] || 'No se pudo descargar el original')
        const bytes = Uint8Array.from(atob(response.data.generateLabelsWelivery), char => char.charCodeAt(0))
        const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
        if (tab) tab.location.href = url
        else {
          const link = document.createElement('a')
          link.href = url
          link.download = 'welivery-' + getLatestDelivery(order).tracking + '.pdf'
          link.click()
        }
        setTimeout(() => URL.revokeObjectURL(url), 60000)
      } catch (error) {
        if (tab) tab.close()
        order.error = error.message
      }
      return true
    },

    cycleGuideSelection () {
      const hasGuide = order => this.hasGuide(order)

      const selectWithGuide = this.guideSelectWithGuideNext
      const target = this.displayOrders.filter(selectWithGuide ? hasGuide : o => !hasGuide(o))

      if (!target.length) {
        this.guideSelectWithGuideNext = !selectWithGuide
        return
      }

      this.displayOrders.forEach(order => {
        this.setMassOrderChecked({
          order: order.order,
          value: selectWithGuide ? hasGuide(order) : !hasGuide(order)
        })
      })

      this.guideSelectWithGuideNext = !selectWithGuide
    },

    canGenerateDelivery (order) {
      if (this.isCollectFreightOrder(order)) return false
      if (!['packed', 'sent'].includes(order.status)) return false
      const delivery = getLatestDelivery(order)
      if (!delivery || delivery.status === 'declined' || delivery.trackingCancelled) return false
      if (this.carrierFor(order) !== 'welivery' && !order.coordinadoraCost) return false
      if (latestDeliveryDiffersFromRecord(order)) return false
      return !this.hasGuide(order)
    },

    canQuoteOrder (order) {
      return this.carrierFor(order) !== 'welivery' && !this.hasGuide(order)
    },

    isCollectFreightOrder (order) {
      return !!(order.userPayConveyor && !order.change)
    },

    canGenerateCollectFreightDelivery (order) {
      if (!this.isCollectFreightOrder(order)) return false
      if (!['packed', 'sent'].includes(order.status)) return false
      const delivery = getLatestDelivery(order)
      if (!delivery || delivery.status === 'declined' || delivery.trackingCancelled) return false
      if (this.carrierFor(order) !== 'welivery' && !order.coordinadoraCost) return false
      if (latestDeliveryDiffersFromRecord(order)) return false
      return !this.hasGuide(order)
    },

    displayFreightCost (order) {
      const delivery = order.deliveries && order.deliveries.at(-1)
      if (this.carrierFor(order) === 'welivery') return delivery && delivery.cost != null ? delivery.cost : 10000
      if (delivery && delivery.status === 'declined') return order.coordinadoraCost || null
      if (delivery && delivery.estimatedCost && !delivery.cost) return delivery.estimatedCost
      if (delivery && delivery.cost) return delivery.cost
      return order.coordinadoraCost || null
    },

    canDownloadDelivery (order) {
      return canDownloadDeliveryLabel(order)
    },

    getUrl () {
      let domain = window.location.hostname
      if (domain === 'pika.sahet.co') domain = 'https://db.sahet.co'
      if (domain === 'localhost') domain = 'http://localhost:3000'
      return domain
    },

    downloadTracking (order) {
      if (this.carrierFor(order) === 'welivery') return this.printWelivery([order])
      const idRemission = order.deliveries.at(-1).idRemission
      const domain = this.getUrl()

      window.open(`${domain}/coordinadora/labels/${idRemission}`, '_blank')
    },

    showDeclared (order, show) {
      this.$set(order, 'showDeclared', show)
      if (!show) {
        this.$nextTick(() => {
          const ref = this.$refs[`declared${order.order}`]
          const input = Array.isArray(ref) ? ref[0] : ref
          if (input) input.focus()
        })
      }
    },

    massFilterTagStyle (key) {
      if (!this.massFilters[key]) return {}

      if (key === 'sahet') {
        return {
          background: 'var(--background-tag-sahet, #f5c518)',
          color: '#fff'
        }
      }

      if (key === 'bassica') {
        return {
          background: 'var(--background-tag-bassica, #00998B)',
          color: '#fff'
        }
      }

      return {
        background: 'var(--color-font-principal, #363636)',
        color: 'var(--background-principal, #fff)'
      }
    },

    toggleMassFilter (key) {
      this.massFilters = Object.assign({}, this.massFilters, {
        [key]: !this.massFilters[key]
      })
    },

    async getQuoteCoordinadora (order) {
      order.error = ''
      order.success = ''
      if (this.carrierFor(order) === 'welivery') {
        order.success = 'Welivery · Costo provisional $10.000'
        return true
      }

      const packagesError = guidePackagesError(order)
      if (packagesError) {
        order.error = packagesError
        this.openedPackageOrder = order.order
        return true
      }

      const packages = guidePackagesInput(order)
      const packageDimensions = packages ? null : packageDimensionsPayload(order)

      const query = gqlCoordinadora.GET_QUOTE_COORDINADORA

      const locationOrigin = 'bogota'
      const departmentOrigin = 'bogota'

      const variables = {
        packagingName: order.package,
        locationOrigin,
        departmentOrigin,
        locationDestination: order.location,
        departmentDestination: order.department,
        value: order.declared,
        isCod: false,
        packageDimensions,
        packages
      }

      const response = await gql.query(query, variables, false, true, true)

      if (response.error) {
        order.error = response.error
        return true
      }

      order.success = 'Cotización Exitosa'

      this.$set(order, 'coordinadoraCost', parseInt(response.data.getQuoteCoordinadora))
      return true
    },

    async generateDelivery (order) {
      if (this.isCollectFreightOrder(order)) {
        order.success = ''
        order.error = 'Esta orden tiene envío al cobro, genera la guía al cobro por fila'
        return true
      }
      if (this.carrierFor(order) === 'welivery') await this.generateDeliveryWelivery(order)
      else await this.generateDeliveryCoordinadora(order, false)
      return true
    },

    async generateDeliveryCollectFreight (order) {
      await this.generateDeliveryCoordinadora(order, true)
      return true
    },

    async generateDeliveryCoordinadora (order, collectFreight = false) {
      order.error = ''
      order.success = ''

      if (!order.coordinadoraCost) {
        order.error = 'No se puede generar la guía porque no se cotizó la orden'
        return true
      }

      const query = gqlCoordinadora.GENERATE_DELIVERY_COORDINADORA
      const packagesError = guidePackagesError(order)
      if (packagesError) {
        order.error = packagesError
        this.openedPackageOrder = order.order
        return true
      }

      const packages = guidePackagesInput(order)
      const packageDimensions = packages ? null : packageDimensionsPayload(order)

      const variables = {
        order: order.order.replace('c', '').trim(),
        package: order.package,
        valueDeclared: order.declared,
        cost: order.coordinadoraCost,
        isChange: !!order.change,
        collectFreight,
        packageDimensions,
        packages
      }
      const errors = []
      const response = await gql.mutate(query, variables, false, errors)

      if (errors.length) {
        order.error = errors[0]
        return true
      }

      const { idRemission, tracking, cost, estimatedCost } = response.data.generateDeliveryCoordinadora

      order.deliveries.at(-1).idRemission = idRemission
      order.deliveries.at(-1).tracking = tracking
      order.deliveries.at(-1).conveyor = 'coordinadora'
      order.deliveries.at(-1).cost = cost
      if (estimatedCost != null) order.deliveries.at(-1).estimatedCost = estimatedCost

      if (collectFreight) {
        order.success = `Guía al cobro generada · Flete est. ${this.money(estimatedCost)}`
      } else {
        order.success = `Guía generada en Coordinadora · Flete ${this.money(cost)}`
      }
      if (!tracking) order.success = `Guía generada en Coordinadora: ${idRemission}, pero no tiene tracking`
      return true
    },

    async generateDeliveryWelivery (order) {
      order.error = ''
      order.success = ''

      const query = gqlWelivery.GENERATE_DELIVERY_WELIVERY

      const variables = { order: order.order.replace('c', '').trim(), isChange: !!order.change, packageCount: order.packages && order.packages.length ? order.packages.length : 1 }
      const errors = []
      const response = await gql.mutate(query, variables, false, errors)

      if (errors.length) {
        order.error = errors[0]
        return true
      }

      const result = response.data.generateDeliveryWelivery
      const delivery = getLatestDelivery(order)
      Object.keys(result).forEach(key => this.$set(delivery, key, result[key]))

      order.success = 'Guía Generada en Welivery'
      return true
    },

    type (order) {
      let text = order || this.order
      if (!text) return

      const firstLetter = text[0].toLowerCase()

      if (firstLetter === 's') return 'order'
      if (firstLetter === 'c') return 'change'
    },

    async getData (order, sound = true) {
      order = order || this.order
      order = order.trim()
      if (this.type(order) === 'order') await this.getDataOrder(order, sound)
      if (this.type(order) === 'change') await this.getDataChange(order, sound)
    },

    async getDataOrder (order, sound = true) {
      order = order || this.order
      const result = await this.fetchMassOrder({ order, sound })

      if (result.notFound) {
        modals.showMessage({ message: `No se encontró la orden ${order}`, type: 'error' })
        this.playSoundError()
      } else if (result.success && sound) {
        if (result.alreadyLoaded) this.playSoundError()
        else this.playSoundTier()
      }

      this.order = ''
    },

    async getDataChange (order, sound = true) {
      order = order || this.order
      const result = await this.fetchMassChange({ changeCode: order, sound })

      if (result.notFound) {
        modals.showMessage({ message: `No se encontró el cambio ${order}`, type: 'error' })
        this.playSoundError()
      } else if (result.success && sound) {
        if (result.alreadyLoaded) this.playSoundError()
        else this.playSoundTier()
      }

      this.order = ''
    },

    playSoundTier () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.tier) {
        this.audios.tier = this.playSound(this.sounds.tier)
      } else {
        this.audios.tier.play()
      }
    },

    playSoundError () {
      if (!this.audios.beepError) {
        this.audios.beepError = this.playSound(this.sounds.beepError)
      } else {
        this.audios.beepError.play()
      }

      if (!this.audios.error) {
        this.audios.error = this.playSound(this.sounds.error)
      } else {
        this.audios.error.play()
      }
    },

    async send (order, showModal = true, showErrors = true) {
      const type = this.type(order)
      if (!type) return

      if (type === 'order') {
        const record = this.orders.find(item => item.order === order)
        if (record && isBlockedByAddressNovelty(record)) {
          const message = addressNoveltyBlockMessage(record)
          if (showErrors) modals.showMessage({ message, type: 'error' })
          return [message]
        }
      }

      let mutation

      if (type === 'order') mutation = gqlOrder.SEND
      if (type === 'change') mutation = gqlChange.SEND

      if (!mutation) return ['No se encontró la mutación']

      const options = {}
      if (type === 'order') options.order = order
      if (type === 'change') {
        options.change = order.replace('c', '')
        options.sendNotifications = true
      }

      const errors = []
      const response = await gql.mutate(mutation, options, showErrors, errors)
      if (response && showModal) modals.showMessage({ message: `Se envió la orden ${order} correctamente` })

      await this.getData(order)

      return errors
    },

    async sendAll () {
      for (let i = 0; i < this.orders.length; i++) {
        const order = this.orders[i]
        if (!order.checked) continue
        const errors = await this.send(order.order, false, false)

        this.$set(order, 'error', '')
        this.$set(order, 'success', '')

        if (errors.length) {
          this.$set(order, 'error', errors[0])
        } else {
          this.$set(order, 'success', 'Pedido Enviado')
          this.$set(order, 'status', 'sent')
        }
      }
    },

    async sleep (time) {
      return new Promise(resolve => setTimeout(resolve, time))
    },

    async downloadLabelsAll () {
      const weliveryOrders = this.displayOrders.filter(order => order.checked && ['packed', 'sent'].includes(order.status) && this.carrierFor(order) === 'welivery' && this.canDownloadDelivery(order))
      if (weliveryOrders.length) this.printWelivery(weliveryOrders)
      const idsRemission = []
      for (let i = 0; i < this.displayOrders.length; i++) {
        const order = this.displayOrders[i]
        order.error = ''
        order.success = ''

        if (!order.checked) continue
        if (order.status !== 'packed' && order.status !== 'sent') {
          order.error = 'No se pudo descargar las guías, el pedido debe estar empacado o enviado'
          continue
        }
        if (!order.deliveries.length) {
          order.error = 'No se pudo descargar las guías, no hay envíos'
          continue
        }
        if (!canDownloadDeliveryLabel(order)) {
          continue
        }
        const idRemission = order.deliveries.at(-1).idRemission
        if (idRemission) idsRemission.push(idRemission)
      }

      const errors = []
      if (!idsRemission.length) {
        if (weliveryOrders.length) return true
        modals.showMessage({ message: 'No se pudo descargar las guías, ninguna guía está generada', type: 'error' })
        return
      }

      const response = await gql.mutate(gqlCoordinadora.GENERATE_LABELS_COORDINADORA, { idsRemission }, false, errors)

      if (errors.length) {
        modals.showMessage({ message: errors[0], type: 'error' })
        return
      }

      const namePdf = response.data.generateLabelsCoordinadora
      const url = this.getUrl()
      window.open(`${url}/coordinadora/labelsJoined/${namePdf}`, '_blank')
    },

    async quoteAll () {
      for (let i = 0; i < this.displayOrders.length; i++) {
        const order = this.displayOrders[i]
        if (!order.checked) continue
        const quoted = await this.getQuoteCoordinadora(order)
        if (!quoted) break
        await this.sleep(500)
      }
    },

    async generateDeliveryAll () {
      for (let i = 0; i < this.displayOrders.length; i++) {
        const order = this.displayOrders[i]
        if (!order.checked) continue

        if (this.isCollectFreightOrder(order)) {
          order.success = ''
          order.error = 'Orden con envío al cobro: generar guía al cobro por fila'
          continue
        }

        const tracking = await this.generateDelivery(order)
        if (!tracking) break
        await this.sleep(500)
      }
    },

    async getUsers () {
      const mutation = gqlUser.GET_ALL

      const errors = []
      const response = await gql.mutate(mutation, { search: '', searchBy: '', limit: 100, page: 1, sort: 'name', order: '' })
      if (response) this.users = response.data.getUsers.docs

      return errors
    }
  }
}
</script>

<style lang="stylus">
.content-section.order-mass-scroll
  overflow hidden

.content.box.order-mass-page
  overflow hidden
  display flex
  flex-direction column
  box-sizing border-box

.order-mass
  display flex
  flex-direction column
  flex 1
  min-height 0
  width 100%
  height 100%

.order-mass__sticky
  flex-shrink 0
  z-index 5
  background var(--background-principal)

.order-mass__body
  flex 1
  min-height 0
  overflow-x auto
  overflow-y auto
  -webkit-overflow-scrolling touch
  padding-bottom 6rem

.order-mass__row
  display flex
  align-items center
  column-gap 0

  &.is-selected
    background var(--color-light)
  width 100%
  min-width 100%
  box-sizing border-box
  border-bottom 1px solid rgba(0, 0, 0, .08)
  padding 1.25rem 0
  text-align left
  font-size 1.15rem
  color #363636

.order-mass__row--header
  padding .5rem 0

.order-mass__row--loader
  justify-content center
  min-height 3.24rem

.order-mass__cell
  box-sizing border-box
  padding-right .5em
  overflow hidden
  text-overflow ellipsis
  min-width 0

.order-mass__row--header .order-mass__cell
  font-weight 400
  color var(--color-placeholder)
  text-transform uppercase

.order-mass__col-check
  flex 0 0 2.75rem
  display flex
  align-items center
  justify-content flex-start
  overflow visible

.order-mass__col-id
  flex 0 0 6rem

.order-mass__col-id .tag
  max-width 100%

.order-mass__col-status
  flex 0 0 12rem
  display flex
  align-items center
  gap .35em

.order-mass__col-status .tag
  flex-shrink 0

.order-mass__col-location
  flex 0 0 7rem

.order-mass__col-date
  flex 0 0 6.5rem

.order-mass__col-guide
  flex 0 0 10rem
  display flex
  flex-wrap wrap
  align-items center
  justify-content flex-start
  gap .25rem
  overflow visible

.order-mass__carrier
  max-width 6.5rem
  padding .2rem
  font-size .85rem
  color inherit
  background transparent
  border 1px solid var(--color-placeholder)
  border-radius .25rem

.order-mass__col-guide > .capitalize
  font-size .85rem

.order-mass__quote-cost
  flex-basis 100%
  margin-left 0
  font-size .95rem
  color var(--color-font-principal)
  white-space nowrap

.order-mass__col-declared
  flex 0 0 8rem

.order-mass__col-value
  flex 0 0 8rem

.order-mass__col-package
  flex 0 0 8.5rem
  display flex
  flex-direction column
  align-items flex-start

.order-mass__col-message
  flex 1 1 0
  min-width 0
  width auto
  overflow visible
  text-overflow clip
  white-space normal
  display flex
  flex-direction column
  align-items flex-start
  justify-content flex-start

.order-mass__col-actions
  flex 0 0 auto
  display flex
  align-items center
  justify-content flex-end
  gap 1rem
  overflow visible

@media (min-width: 769px)
  .order-mass__col-check
    flex 0 0 2.75rem

  .order-mass__col-id
    flex 0 0 6.5rem

  .order-mass__col-status
    flex 0 0 12rem

  .order-mass__col-location
    flex 0 0 8rem

  .order-mass__col-date
    flex 0 0 7rem

  .order-mass__col-message
    flex 1 1 0

  .order-mass__col-declared
    flex 0 0 9rem

  .order-mass__col-value
    flex 0 0 9rem

  .order-mass__col-guide
    flex 0 0 9rem

  .order-mass__col-package
    flex 0 0 10rem

.message-mass
  line-height 1.3

.message-mass .color-green,
.message-mass .color-red
  width 100%
  max-width 100%
  overflow-wrap anywhere
  word-break break-word

.input-declared
  width 7.5rem
  color var(--color-font-primary)
  padding .5rem
  font-size 1rem
  text-align center

.container-actions-mass
  display flex
  align-items center
  justify-content flex-end
  gap .75rem

.order-mass__guide-header
  cursor pointer
  user-select none

  &:hover
    text-decoration underline

.order-mass__order-link
  cursor pointer

  &:hover
    opacity .75

@media (max-width: 768px)
  .order-mass__col-check
    display none
</style>

<style lang="stylus" scoped>
.order-mass
  padding 0

.order-mass__record-filters
  display flex
  flex-wrap wrap
  gap .75rem
  margin 0 0 .75rem

.order-mass__record-filter-tag
  flex 0 0 auto
  min-height 2rem
  padding .35rem .85rem
  box-sizing border-box
  display flex
  align-items center
  justify-content center
  border none
  border-radius .35rem
  font-size .9rem
  font-weight 400
  text-transform uppercase
  opacity .4
  cursor pointer
  user-select none
  -webkit-tap-highlight-color transparent
  touch-action manipulation
  transition background-color .15s ease, color .15s ease, transform .1s ease, opacity .15s ease
  background var(--color-light, rgba(0, 0, 0, .06))
  color var(--color-font-principal, #363636)

  &.is-active
    opacity 1
    box-shadow 0 2px 8px rgba(0, 0, 0, .12)

  &:active
    transform scale(.97)
    opacity .9

.order-mass__actions
  margin-bottom .75rem

.order-mass__status-count
  margin 1.25rem 0 2rem .3rem
  font-size 1.1rem
  text-transform lowercase

.order-mass__status-count b
  font-weight 700

.order-mass__toolbar
  display flex
  flex-wrap wrap
  gap .75rem
</style>



// WEBPACK FOOTER //
// src/components/pages/order/mass/Guides.vue